module.exports = __webpack_public_path__ + "static/img/2.a65dfdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/2.png
// module id = 0i44
// module chunks = 0